import React from 'react';
import Spinner from '../spinner';

const Button = ({
  type,
  block,
  loading,
  label,
  disabled,
  onClick,
  style,
  className: classNameProp,
  children,
  ...rest
}) => {
  const isHtmlButtonType = type === 'submit' || type === 'reset';
  const isHtmlTypeOnly = type === 'button' || isHtmlButtonType;
  const htmlType = isHtmlButtonType ? type : 'button';
  const variantType = isHtmlTypeOnly ? undefined : type;

  let background;
  let textColor;
  let border = '';
  switch (variantType) {
    case 'primary':
      background = 'bg-lightGreen hover:bg-greenHover';
      textColor = 'text-green';
      break;
    case 'secondary':
      background = 'bg-btnSecondaryBg hover:bg-btnSecondaryHover';
      textColor = 'text-btnSecondaryText';
      break;
    case 'danger':
      background = 'bg-red hover:bg-red-600';
      textColor = 'text-white';
      break;
    case 'link':
      background = 'bg-transparent hover:bg-red-50';
      textColor = 'text-red';
      break;
    default:
      background = 'bg-red hover:bg-red-600';
      textColor = 'text-white';
      border = 'border border-white border-opacity-10';
      break;
  }

  return (
    <div className={`${block ? 'w-full' : 'w-max'} mx-2`}>
      <button
        type={htmlType}
        disabled={disabled}
        onClick={onClick}
        style={style}
        className={`${background} min-w-full py-2 px-4 rounded-md ${textColor} ${border} justify-center items-center flex transition-colors duration-200 ${
          variantType !== 'link' && 'shadow-sm'
        } ${
          disabled
            ? 'cursor-not-allowed bg-opacity-50'
            : 'cursor-pointer bg-opacity-100'
        } ${classNameProp || ''}`}
        {...rest}>
        <div className="flex flex-row items-center">
          {loading ? <Spinner /> : null}
          <p className={`${textColor} text-center  text-xs`}>
            {label ?? children}
          </p>
        </div>
      </button>
    </div>
  );
};

export default Button;
